// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__37kjn","rightSection":"Header_rightSection__ilzKh","actionButton":"Header_actionButton__16lGn","languageSelect":"Header_languageSelect__18Mp_"};